export enum RolesEnum {
  administrator = 1,
  user = 2
}
